<template>
  <div class="dashboard-main-container">
    <public-header :show-logo="true" />
    <div class="dashboard-content">
      <router-view />
    </div>
  </div>
</template>
<script>
import PublicHeader from '@/components/PublicHeader'

export default {
  components: {
    PublicHeader
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables';

.dashboard-main-container {
  @include gradient-radial(#f8f8f8, #eee);
  @media screen {
    height: 100vh;
    overflow: auto;
  }
  flex-grow: 1;
  padding-left: 30px;
  padding-right: 30px;
}
.dashboard-content {
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
  height: calc(100vh - 140px);
}
</style>
